import { render, staticRenderFns } from "./Profile1.container.vue?vue&type=template&id=4dee92be&scoped=true&"
import script from "./Profile1.container.vue?vue&type=script&lang=js&"
export * from "./Profile1.container.vue?vue&type=script&lang=js&"
import style0 from "./Profile1.container.vue?vue&type=style&index=0&id=4dee92be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee92be",
  null
  
)

export default component.exports